import { Avatar, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import { generosEnum } from '../../../../../widgets/fields/GenerosField';
import { getTipoSangre } from '../../../../../widgets/fields/TiposSangreField';
import { getFilesArchivos } from '../../../../archivos/HelpersArchivos';

const InformacionDocenteComponent = () => {
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const activo = docentesStore.activo;

  return (
    <Paper elevation={4}>
      <Grid container spacing={0}>
        <Grid item md={12} align="center">
          <Avatar
            alt={activo.usuario.perfil.pnombre}
            sx={{ width: 150, height: 150, my: 2 }}
            src={getFilesArchivos(activo.usuario.perfil.avatar)}
          />
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">
            {activo.usuario.perfil.tipoDni}-{activo.usuario.perfil.dni}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">{activo.usuario.perfil.pnombre}</Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Typography variant="h6">
            {activo.usuario.perfil.papellido}
          </Typography>
        </Grid>
        <Grid item md={12} align="center">
          <Divider textAlign="left" sx={{}}>
            Detalles
          </Divider>
        </Grid>
        <Grid item md={12} sx={{ p: 2 }}>
          <Grid container spacing={0}>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Correo: </strong>
                {activo.usuario.correo}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Fecha de nacimiento: </strong>
                {activo.usuario.perfil.fechaNacimiento}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Genero: </strong>
                {generosEnum[activo.usuario.perfil.genero]}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Tipo sangre: </strong>
                {getTipoSangre(activo.usuario.perfil.tipoSangre)}
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography variant="body">
                <strong>Tiene internet: </strong>
                {activo.usuario.perfil.internet ? 'SI' : 'NO'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default InformacionDocenteComponent;
